import HelloSign from 'hellosign-embedded'
import { useEffect, useRef } from 'react'
import { Handler } from 'shared/helpers/typeHelper'
import { styled } from 'styled-components'

import { isDevelopmentEnv } from '../../config/config'

interface DropboxSignEnvelopeProps {
  url: string
  integrationKey: string
  onAgree: Handler
  onError: Handler
}

export function DropboxSignEnvelope({ url, integrationKey, onAgree }: DropboxSignEnvelopeProps) {
  const container = useRef<HTMLDivElement>(null)
  const handleAgree = useRef(onAgree)

  useEffect(() => {
    handleAgree.current = onAgree
  })

  useEffect(() => {
    const client = ((window as any).dropboxSignClient = new HelloSign())

    client.open(url, {
      clientId: integrationKey,
      skipDomainVerification: true,
      allowCancel: false,
      container: container.current!,
      debug: isDevelopmentEnv(),
    })

    client.on('sign', (data: any) => {
      console.warn('The document has been signed!', data)
      client.close()
      handleAgree.current()
    })
  }, [integrationKey, url])

  return <Wrap ref={container} />
}

const Wrap = styled.div`
  height: 100%;
  min-height: 100%;
`
